import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { ApiError } from "./api/client";
import { FlashProvider } from "./components/Flash";
import "./styles.css";
import "./theme.css"; // the blue look; remove this line to go back to the plain one
import "./mobile.css"; // phone layouts; remove this line to go back to the desktop layout on phones
import "./dark.css"; // dark mode; remove this line (and the theme switch) to go back to light only
import { startTheme } from "./lib/theme";

startTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Don't retry "not found" / "signed out" style errors.
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <FlashProvider>
          <App />
        </FlashProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
